// src/pdfs/generateIDCard.js
import jsPDF from "jspdf";
import QRCode from "qrcode";

export default async function GenerateIDCard(member) {
  const doc = new jsPDF("landscape", "mm", [85.6, 54]);

  doc.setDrawColor(0);
  doc.setLineWidth(0.6);
  doc.roundedRect(2, 2, 81.6, 50, 2, 2);

  let y = 10;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor("#0a3d91");
  doc.text("SHINE AGRI ALLIED AND MARKETING", 42.8, y, { align: "center" });
  y += 4;
  doc.text("MULTISTATE COOPERATIVE SOCIETY LTD.", 42.8, y, { align: "center" });
  y += 4;
  doc.setFontSize(6);
  doc.setTextColor("black");
  doc.text("48, 1st Floor, Amar Arcade, Nilpur, Ta-Dantiwada", 42.8, y, { align: "center" });
  y += 3;
  doc.text("Dist-Banaskantha, Gujarat – 385505", 42.8, y, { align: "center" });
  y += 3;
  doc.text("Email: saamcopsociety@gmail.com", 42.8, y, { align: "center" });

  y += 2.5;
  doc.setDrawColor("#999");
  doc.setLineWidth(0.2);
  doc.line(5, y, 80.6, y);
  y += 3;

  doc.setFontSize(7);
  const labelX = 8;
  const colonX = 36;
  const valueX = 40;

  const info = [
    ["Member Name", member.name],
    ["Membership No", member.member_id],
    ["Valid Till", "Lifetime"]
  ];

  info.forEach(([label, value]) => {
    doc.setFont("Times", "bold");
    doc.text(label, labelX, y);
    doc.setFont("Times", "normal");
    doc.text(":", colonX, y);
    const wrappedValue = doc.splitTextToSize(value || "____________", 38);
    doc.text(wrappedValue, valueX, y);
    y += wrappedValue.length * 4;
  });

  const qrText = `${member.member_id}\n${member.name}`;
  const qrImage = await QRCode.toDataURL(qrText);
  doc.addImage(qrImage, "PNG", 62, 30, 18, 18);

  doc.save(`IDCard_${member.member_id}.pdf`);
}
